import { default as dropdown } from "./dropdown";
import DropdownToggle from "./dropdownToggle";
import DropdownItem from "./dropdownItem";
import DropdownMenu from "./dropdownMenu";
import DropdownOptions from "./dropdownOptions";
import DropdownPanel from "./dropdownPanel";

export * from "./dropdown";
export * from "./dropdownToggle";
export * from "./dropdownItem";
export * from "./dropdownMenu";
export * from "./dropdownOptions";
export * from "./dropdownPanel";

const Dropdown = Object.assign(dropdown, {
  Toggle: DropdownToggle,
  Panel: DropdownPanel,
  Menu: DropdownMenu,
  Item: DropdownItem,
  Options: DropdownOptions,
});

export default Dropdown;
